import { Factory, QuickFactory } from '@infodata-group/inf-commons';
import { Alarm } from '../model/alarm/alarm';

export class AlarmFactory extends QuickFactory implements Factory<Alarm> {
  id: string;

  constructor(id?: string) {
    super();
    this.id = id;
  }

  build(o: any): Alarm {
    const alarm = new Alarm();
    this.generateProperty(alarm, o);
    alarm.id = o.id;
    alarm.label = o.label;
    alarm['statusLabel'] = o.statusId;
    return alarm;
  }

  getApi(): string {
    return this.id
      ? `administration/alarmes/${this.id}`
      : 'administration/alarmes/';
  }
}
